var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F49E00",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 23H8V21.4444H8.8V9.77778C8.8 9.5715 8.88429 9.37367 9.03431 9.22781C9.18434 9.08194 9.38783 9 9.6 9H20.8C21.0122 9 21.2157 9.08194 21.3657 9.22781C21.5157 9.37367 21.6 9.5715 21.6 9.77778V13.6667H23.2V21.4444H24V23ZM20 21.4444H21.6V15.2222H16.8V21.4444H18.4V16.7778H20V21.4444ZM20 13.6667V10.5556H10.4V21.4444H15.2V13.6667H20ZM12 15.2222H13.6V16.7778H12V15.2222ZM12 18.3333H13.6V19.8889H12V18.3333ZM12 12.1111H13.6V13.6667H12V12.1111Z",
    fill: "#F49E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.1c4fd7c816d2afdc47295b2554dea1c9.svg";
export { ForwardRef as ReactComponent };